import Account from "@/helper/AccountHelper.js";
import ConfigManager from "@/config/ConfigManager.js";
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';
// import ResponseRegister from '../../../testJson/ResponseRegister.json'
export default {

    verifyMember: function(idCard, contactNumber) {

        const token = Account.getToken();
        const params = {
            contact_number: contactNumber,
            idCard: idCard,
        };

        const url = ConfigManager.getApiModuleUrl() + "/user/member";
        return BzbsApi.connectBzbsGet(url, token, params).pipe(map(res => res.data));
    },
    registerMember: function(params) {

        const token = Account.getToken();
        // const params = {
        //     contact_number: contactNumber,
        //     idCard: idCard,
        // };

        const url = ConfigManager.getApiModuleUrl() + "/user/register";
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map(res => {
            // let point = res.data?.data?.buzzebees?.Points;
            let point = res.data?.data?.buzzebees.length ? res.data.data.buzzebees[0].Points : 0;
            return point;
        }));
    },
    getPolicy: function(registerData) {
        //https://dev-module-tipcoin.azurewebsites.net/user/getpolicy?idcard=1349900696510&firstname=SRIKOTE&lastname=NAEWCHAMPA'
        const token = Account.getToken();
        const params = {
            firstname: registerData.firstName,
            lastname: registerData.lastName,
            idcard: registerData.idcard,
        };
        const url = ConfigManager.getApiModuleUrl() + "/user/getpolicy";
        return BzbsApi.connectBzbsGet(url, token, params).pipe(map(res => res.data));
    },
}
